import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-tip-platform-verification-code-modal',
  templateUrl: './tip-platform-verification-code-modal.component.html',
  styleUrls: ['./tip-platform-verification-code-modal.component.scss'],
})
export class TipPlatformVerificationCodeModalComponent {
  constructor(
    private dialogRef: MatDialogRef<TipPlatformVerificationCodeModalComponent>
  ) {}
  close() {
    this.dialogRef.close();
  }

  onOk() {
    this.dialogRef.close('ok');
  }
}
